import React, { useState, useContext, useEffect } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useNavigate, Navigate, Link } from 'react-router-dom';
import logomuseu from "../assets/logomuseu.png";
import Swal from 'sweetalert2';
import { AuthContext } from '../contexts/AuthContext';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faLock, faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import "../scss/admin/login.scss";

export default function Login() {
    const { signin, token } = useContext(AuthContext);
    const navigate = useNavigate();
    const [usuario, setUsuario] = useState({ email: "", senha: "" });

    useEffect(() => {
        if (token) navigate('/admin');
    }, [token, navigate]);

    const handleChange = (e) => {
        setUsuario({ ...usuario, [e.target.name]: e.target.value });
    };

    const handleLogin = async (event) => {
        event.preventDefault();
        const isLogged = await signin(usuario.email, usuario.senha);
        if (!isLogged) {
            Swal.fire({
                title: "Falha no Login",
                text: "Credenciais inválidas.",
                icon: "error",
                confirmButtonColor: '#587b7f'
            });
        }
    };

    if (token) return <Navigate to="/admin" replace={true} />;

    return (
        <div className="login-page-container">
            <div className="login-card">
                {/* Lado Esquerdo - Informativo */}
                <div className="login-side-info">
                    <img src={logomuseu} alt="Logo Museu" className="login-logo" />
                    <h1 className="info-title">Centro de Memória e Museu Histórico</h1>
                    <p className="info-subtitle">FMRP / USP — Faculdade de Medicina de Ribeirão Preto</p>
                    <p className="info-description">
                        Acesse o painel administrativo para gerenciar o acervo de equipamentos históricos e o acervo iconográfico do museu.
                    </p>
                </div>

                {/* Lado Direito - Formulário */}
                <div className="login-side-form">
                    <div className="form-header">
                        <h2>Acesso Administrativo</h2>
                        <p>Entre com suas credenciais</p>
                    </div>

                    <Form onSubmit={handleLogin}>
                        <Form.Group className="mb-3">
                            <Form.Label>E-mail</Form.Label>
                            <div className="input-group-custom">
                                <FontAwesomeIcon icon={faEnvelope} className="input-icon" />
                                <Form.Control
                                    type="email"
                                    name="email"
                                    placeholder="seu@email.com"
                                    value={usuario.email}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Senha</Form.Label>
                            <div className="input-group-custom">
                                <FontAwesomeIcon icon={faLock} className="input-icon" />
                                <Form.Control
                                    type="password"
                                    name="senha"
                                    placeholder="********"
                                    value={usuario.senha}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                        </Form.Group>

                        <div className="text-end mb-4">
                            <Link to="/email" className="forgot-password">Esqueceu a senha?</Link>
                        </div>

                        <Button className="btn-login-submit" type="submit">
                            Entrar
                        </Button>
                    </Form>

                    <div className="form-footer">
                        <Link to="/" className="back-to-site">
                            <FontAwesomeIcon icon={faArrowLeft} className="me-2" />
                            Voltar ao site do museu
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}